import { useState, useEffect } from "react";
import axios from 'axios';
const API_KEY = process.env.REACT_APP_YOUTUBE_API_KEY;

const API_URL = 'https://tsoministries.com/wp-json/wp/v2/youtube_resource';

export const fetchYouTubeResources_ = async (type) => {
  try {
    const res = await axios.get(API_URL, {
      params: {
        per_page: 100,
        // meta_key: 'type',
        // meta_value: type
      }
    });
    const data = res.data.map(item => ({
        id: item.id,
        title: item.title.rendered,
        duration: item.meta.duration,
        thumbnail: item.meta.thumbnail,
        description: item.content.rendered,
        link: item.meta.youtube_url,
        publishedAt: new Date(item.date),
        type: item.meta.type
      }));
    return data;
  } catch (err) {
    console.error("Error fetching YouTube resources", err);
    return [];
  }
};

export const fetchYouTubeResources = async (type) => {
    try {
      const res = await axios.get(API_URL, {
        params: {
          per_page: 100,
        },
      });
  
      const filtered = res.data.filter(item => item.meta?.type === type);
  
      const sorted = filtered.sort((a, b) => {
        return new Date(b.meta?.publishedAt) - new Date(a.meta?.publishedAt);
      });
  
      return sorted.map(item => ({
        id: item.id,
        title: item.meta.title,
        duration: item.meta.duration,
        thumbnail: item.meta.thumbnail,
        description: item.meta.description,
        link: item.meta.link,
        publishedAt: formatReadableDate(item.meta.publishedAt),
        type: item.meta.type
      }));
    } catch (err) {
      console.error("Error fetching YouTube resources", err);
      return [];
    }
  };


const useFetchYouTubeResources = (videoLinks, audioLinks) => {
    const [resources, setResources] = useState([]);

    useEffect(() => {
        const STORAGE_KEY = "youtube_resources";

        const fetchVideoDetails = async (links, type) => {
            const videoIds = links.map((link) => extractVideoId(link)).filter(Boolean);
            if (videoIds.length === 0) return [];

            try {
                const response = await fetch(
                    `https://www.googleapis.com/youtube/v3/videos?part=snippet,contentDetails&id=${videoIds.join(",")}&key=${API_KEY}`
                );
                const data = await response.json();

                return data.items.map((video) => ({
                    id: video.id,
                    title: video.snippet.title,
                    type,
                    duration: parseISO8601Duration(video.contentDetails.duration),
                    thumbnail: video.snippet.thumbnails.high.url,
                    description: video.snippet.description,
                    link: `https://www.youtube.com/watch?v=${video.id}`,
                    publishedAt: new Date(video.snippet.publishedAt),
                }));
            } catch (error) {
                console.error("Error fetching YouTube data:", error);
                return [];
            }
        };

        const loadResources = async () => {
            // Try fetching from local storage first
            const cachedData = localStorage.getItem(STORAGE_KEY);
            if (cachedData) {
                setResources(JSON.parse(cachedData));
            }

            // Fetch fresh data
            const videoData = await fetchVideoDetails(videoLinks, "video");
            const audioData = await fetchVideoDetails(audioLinks, "audio");

            const sortedResources = [...videoData, ...audioData].sort(
                (a, b) => b.publishedAt - a.publishedAt
            );

            setResources(sortedResources);

            // Store in localStorage for future use
            localStorage.setItem(STORAGE_KEY, JSON.stringify(sortedResources));
        };

        loadResources();
    }, [videoLinks, audioLinks]);

    return resources;
};


// export const justFetchYouTubeResources = async (videoLinks, audioLinks) => {
//     let resources = [];

//     const STORAGE_KEY = "youtube_resources";

//     const fetchVideoDetails = async (links, type) => {
//         const videoIds = links.map((link) => extractVideoId(link)).filter(Boolean);
//         if (videoIds.length === 0) return [];

//         try {
//             const response = await fetch(
//                 `https://www.googleapis.com/youtube/v3/videos?part=snippet,contentDetails&id=${videoIds.join(",")}&key=${API_KEY}`
//             );
//             const data = await response.json();

//             return data.items.map((video) => ({
//                 id: video.id,
//                 title: video.snippet.title,
//                 type,
//                 duration: parseISO8601Duration(video.contentDetails.duration),
//                 thumbnail: video.snippet.thumbnails.high.url,
//                 description: video.snippet.description,
//                 link: `https://www.youtube.com/watch?v=${video.id}`,
//                 publishedAt: new Date(video.snippet.publishedAt),
//             }));
//         } catch (error) {
//             console.error("Error fetching YouTube data:", error);
//             return [];
//         }
//     };

//     // Fetch fresh data
//     const videoData = fetchVideoDetails(videoLinks, "video");
//     // const audioData = fetchVideoDetails(audioLinks, "audio");

//     // const sortedResources = videoData.sort(
//     //     (a, b) => b.publishedAt - a.publishedAt
//     // );

//     resources = videoData;

//     return resources;
// };

// Extract Video ID from a YouTube URL
export const extractVideoId = (url) => {
    const match = url.match(/(?:youtube\.com\/(?:.*v=|.*\/|.*vi=)|youtu\.be\/|youtube.com\/embed\/)([^?&]+)/);
    return match ? match[1] : null;
};

// Convert ISO8601 duration format (PT1H2M3S) to readable format
export const parseISO8601Duration = (duration) => {
    const match = duration.match(/PT(\d+H)?(\d+M)?(\d+S)?/);
    const hours = match[1] ? match[1].replace("H", "") : "0";
    const minutes = match[2] ? match[2].replace("M", "") : "0";
    const seconds = match[3] ? match[3].replace("S", "") : "0";

    return `${hours !== "0" ? `${hours}:` : ""}${minutes}:${seconds.padStart(2, "0")}`;
};

export function truncateHTML(html, maxLength = 100) {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    const text = tempDiv.textContent || tempDiv.innerText || '';
    return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
  }

  export function formatReadableDate(dateString) {
    const date = new Date(dateString);
  
    if (isNaN(date)) return 'Invalid date';
  
    const options = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    };
  
    return date.toLocaleString(undefined, options); // Uses user's locale
  }

export default useFetchYouTubeResources;